module.exports = __webpack_public_path__ + "media/icons/smartsearch/materials/pt-4c37264620dd9dc27156b89f6b2f82a3.png";